import { RouteComponentProps } from '@reach/router'
import * as React from 'react'
import styled from 'styled-components'
import Checkbox from '../../../../common/src/components/Checkbox'
import { ListItem, Dropdown } from '../../../../common/src/components/Dropdown'
import Table from '../../../../common/src/components/Table'
import TableMultiselect from '../../../../common/src/components/TableMultiselect'
import Toggle from '../../../../common/src/components/Toggle'
import { H1, Spacer, H2, H3, H4, IntroText, BodyText } from '../../../../common/src/components/core'

export default class ComponentsPage extends React.PureComponent<
  RouteComponentProps,
  {
    toggleChoice: string
    multiChoices: string[]
    checked: boolean
    dropdownSelectedItemId: number | undefined
    extraDropdownItems: ListItem<number>[]
  }
> {
  constructor(props: ComponentsPage['props']) {
    super(props)

    const extraDropdownItems: ListItem<number>[] = []

    for (let i = 0; i < 20; i++) {
      extraDropdownItems.push({
        id: i + 100,
        name: `test item ${i}`,
      })
    }

    this.state = {
      toggleChoice: 'pulp',
      multiChoices: [],
      checked: false,
      dropdownSelectedItemId: undefined,
      extraDropdownItems,
    }
  }

  render() {
    const { checked } = this.state

    return (
      <ComponentsPageWrap>
        <H1>H1 - Components Page</H1>
        <Spacer height={32} />
        <H2>H2 - This is a main subtitle</H2>
        <Spacer height={32} />
        <H3>H3 - This is a section title</H3>
        <Spacer height={32} />
        <H4>H4 - This is a section subtitle</H4>
        <Spacer height={32} />
        <IntroText>
          This an introduction text. It has a fixed size, and a custom line height, so you can experiment with it. Lorem
          ipsum dolor sit amet, consectetur adipiscing elit. Cras dapibus vulputate diam eu pretium.
        </IntroText>
        <Spacer height={32} />
        <BodyText>
          The benefits of a solid body style are well understood. Cras dapibus vulputate diam eu pretium. Mauris elit
          orci, ultricies id fermentum vel, porta et eros. Vestibulum condimentum lectus in convallis feugiat. Sed
          vulputate fringilla felis. Aliquam ut arcu et dui feugiat scelerisque eu quis diam. Mauris placerat congue dui
          sit amet blandit. Phasellus condimentum libero vel velit auctor, sit amet tincidunt velit varius. Mauris
          lacinia porta faucibus. Fusce eu est ac eros vulputate mollis in ac felis. Aenean commodo scelerisque mi sed
          imperdiet. Donec at hendrerit nisi, eget vestibulum nisi. Sed sit amet magna luctus, facilisis erat quis,
          sagittis ligula. Aenean dignissim velit quis leo consequat ultricies. Proin quis pretium justo. Vestibulum at
          eros nisl. Fusce lobortis erat ante, eu cursus sapien molestie at. Pellentesque placerat ante diam, et euismod
          lacus dictum vel. Phasellus vitae sollicitudin mi.
        </BodyText>
        <Spacer height={32} />
        <Toggle options={this.toggleOpts} value={this.state.toggleChoice} onSelect={this.toggleSelect} />
        <Spacer height={32} />
        <Toggle options={this.toggleOpts} values={this.state.multiChoices} onSelect={this.multiSelect} multiselect />
        <Spacer height={32} />
        <Dropdown
          selectedItemId={this.state.dropdownSelectedItemId}
          onSelectedItemChange={this.onSelectedItemChange}
          items={[
            {
              id: 1,
              name: 'ivan',
            },
            {
              id: 2,
              name: 'rob',
            },
            {
              id: 3,
              name: 'dc',
            },
            {
              id: 4,
              name: 'kyle',
            },
            {
              id: 5,
              name: 'goblin',
              disabled: true,
            },
            {
              id: 6,
              name: 'david',
            },
            ...this.state.extraDropdownItems,
          ]}
        />
        <Spacer height={32} />
        <BodyText>
          <Checkbox check="checked" disabled /> checked
          <Spacer width={32} />
          <Checkbox check="unchecked" disabled /> unchecked
          <Spacer width={32} />
          <Checkbox check="indeterminate" disabled /> indeterminate
          <Spacer width={32} />
          <Checkbox check={checked ? 'checked' : 'unchecked'} onClick={this.toggleCheck} /> enabled
        </BodyText>
        <Spacer height={32} />
        <Columns>
          <Col>
            <Table
              rows={demoOffices}
              columns={[(r: Office) => r.city, (r: Office) => r.state]}
              headers={['City', 'State']}
            />
          </Col>
          <Col>
            <TableMultiselect
              rows={demoOffices}
              columns={[(r: Office) => r.city, (r: Office) => r.state]}
              headers={['City', 'State']}
            />
          </Col>
        </Columns>

        <Spacer height={96} />
      </ComponentsPageWrap>
    )
  }

  private onSelectedItemChange = (item: ListItem<number> | undefined) => {
    this.setState({ dropdownSelectedItemId: item ? item.id : undefined })
  }

  private toggleCheck = () => this.setState({ checked: !this.state.checked })

  private toggleSelect = (vals: string[]) => {
    this.setState({ toggleChoice: vals[0] })
  }

  private multiSelect = (vals: string[]) => {
    this.setState({ multiChoices: vals })
  }

  private toggleOpts = [
    { key: 'pulp', name: 'Pulp Fiction' },
    { key: 'dogs', name: 'Reservoir Dogs' },
    { key: 'bill', name: 'Kill Bill' },
  ]
}

const Columns = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 -32px;
`

const Col = styled.div`
  margin: 0 32px;
`

interface Office {
  city: string
  state: string
}

const demoOffices = [
  {
    city: 'Goleta',
    state: 'California',
  },
  {
    city: 'Venice',
    state: 'California',
  },
  {
    city: 'San Diego',
    state: 'California',
  },
  {
    city: 'Houston',
    state: 'Texas',
  },
  {
    city: 'Oakland',
    state: 'California',
  },
  {
    city: 'New York',
    state: 'New York',
  },
]

const ComponentsPageWrap = styled.div`
  width: 800px;
  margin: 0 auto;
  padding: 32px;
`
